export default "__VITE_ASSET__dedc7d12__"